// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class Counter extends Vue {
  private secondDivider = 1000;
  private minuteDivider = this.secondDivider * 60;
  private hourDivider = this.minuteDivider * 60;
  private dayDivider = this.hourDivider * 24;
  private seconds = 0;
  private minutes = 0;
  private hours = 0;
  private days = 0;
  private offset = Date.now();
  private timer: any = null;

  @Prop({ default: () => new Date() })
  public targetDate!: Date;

  @Prop({ default: () => new Date() })
  public currentDate!: Date;

  @Prop({ default: "d" })
  public dayTitle!: string;

  @Prop({ default: "h" })
  public hourTitle!: string;

  @Prop({ default: "m" })
  public minuteTitle!: string;

  @Prop({ default: "s" })
  public secondTitle!: string;

  @Prop({ default: "white" })
  public fontColor!: string;

  private forceHide: boolean = false;

  get dateDistance() {
    return this.targetDate.getTime() - this.currentDate.getTime();
  }

  get isVisible() {
    return (
      !this.forceHide &&
      this.targetDate.getTime() - this.currentDate.getTime() > 0
    );
  }

  get secondString() {
    return this.zeroPad(this.seconds);
  }

  get minuteString() {
    return this.zeroPad(this.minutes);
  }

  get hourString() {
    return this.zeroPad(this.hours);
  }

  get dayString() {
    return this.zeroPad(this.days);
  }

  private zeroPad(number) {
    if (number < 10) {
      return ("0" + number).slice(-2);
    } else {
      return "" + number;
    }
  }

  private update() {
    let distance = this.dateDistance - (Date.now() - this.offset);
    if (distance > 0) {
      this.seconds = Math.floor(
        (distance % this.minuteDivider) / this.secondDivider
      );
      this.minutes = Math.floor(
        (distance % this.hourDivider) / this.minuteDivider
      );
      this.hours = Math.floor((distance % this.dayDivider) / this.hourDivider);
      this.days = Math.floor(distance / this.dayDivider);
    } else {
      this.forceHide = true;
    }
  }

  public mounted() {
    let distance = this.dateDistance - (Date.now() - this.offset);
    if (distance > 0) {
      let seconds = Math.floor(
        (distance % this.minuteDivider) / this.secondDivider
      );
      let minutes = Math.floor(
        (distance % this.hourDivider) / this.minuteDivider
      );
      let hours = Math.floor((distance % this.dayDivider) / this.hourDivider);
      let days = Math.floor(distance / this.dayDivider);

      this.animateNumber(
        0,
        seconds,
        1500,
        (number) => (this.seconds = Math.ceil(number))
      );

      this.animateNumber(
        0,
        minutes,
        1500,
        (number) => (this.minutes = Math.ceil(number))
      );

      this.animateNumber(
        0,
        hours,
        1500,
        (number) => (this.hours = Math.ceil(number))
      );

      this.animateNumber(
        0,
        days,
        1500,
        (number) => (this.days = Math.ceil(number))
      );

      setTimeout(() => {
        this.timer = setInterval(this.update, 1000);
      }, 1500);
    }
  }

  public animateNumber(begin, end, duration, stepFn) {
    let start: number;
    let lastNumber = begin;

    let animateFn = (now) => {
      if (!start) {
        start = now;
      }
      let elapsed = now - start;
      let percentElapsed = Math.min(elapsed / duration, 1);
      let nextNumber = (end - begin) * percentElapsed + begin;

      if (nextNumber != lastNumber) {
        lastNumber = nextNumber;
        stepFn(nextNumber);
      }
      if (elapsed < duration) {
        requestAnimationFrame(animateFn);
      }
    };

    stepFn(lastNumber);
    requestAnimationFrame(animateFn);
  }
}
